<pbc-filter-preset
  [filter]="kunden.preset$ | async"
  [filters]="kunden.presets$ | async"
  [name]="kunden.search$ | async"
  (select)="kunden.setFilter($event)"
  (save)="kunden.writeFilter($event)"
  (delete)="kunden.deleteFilter($event)"
></pbc-filter-preset>
